import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Anchor, GradientBackground, StyledImage, StyledImageWithFocalPoint, Subtitle } from "../LinkGrid.styles";
export var GridImageLink = function(param) {
    var _content = param.content, href = _content.href, image = _content.image, label = _content.label, _rules = param.rules, color = _rules.color, layout = _rules.layout, hidden = _rules.hidden;
    /*#__PURE__*/ return _jsxs(Anchor, {
        bgColor: color,
        layout: layout,
        href: href,
        hidden: !!hidden,
        children: [
            (image === null || image === void 0 ? void 0 : image.src) && image.focalPoint && /*#__PURE__*/ _jsx(StyledImageWithFocalPoint, _object_spread({}, image)),
            (image === null || image === void 0 ? void 0 : image.src) && !image.focalPoint && /*#__PURE__*/ _jsx(StyledImage, _object_spread({
                layout: "fill",
                objectFit: "cover"
            }, image)),
            /*#__PURE__*/ _jsx(GradientBackground, {
                children: /*#__PURE__*/ _jsx(Subtitle, {
                    as: "span",
                    textColor: "white",
                    children: label
                })
            })
        ]
    });
};
